import React from 'react';
import { InputAdornment, OutlinedInput, Toolbar } from '@mui/material';
import { Search } from 'lucide-react';
import { ButtonAdd } from '../../components/Element/ButtonAdd';
const LocationToolbar = ({
    search,
    onSearch,
    handleAddLocation,
    textButtonAdd = 'เพิ่มสถานที่',
}: {
    search: string;
    textButtonAdd?: string;
    onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleAddLocation: () => void;
}) => {
    return (
        <Toolbar sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 2, // Consistent gap between items
            width: '100%',
            p: { xs: 2, sm: 0 }, // Add padding on mobile view inside the toolbar
        }}>
            <OutlinedInput
                fullWidth
                size="small"
                value={search}
                type="search"
                onChange={onSearch}
                placeholder="ค้นหาสถานที่... "
                startAdornment={
                    <InputAdornment position="start">
                        <Search size={20} strokeWidth={1.5} absoluteStrokeWidth />
                    </InputAdornment>
                }
                sx={{
                    borderRadius: 2,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#6CB2A1',
                    },
                    width: { xs: '100%', sm: 'auto' },
                    maxWidth: { xs: '100%', sm: 250 },
                }}
            />
            <ButtonAdd text={textButtonAdd} onClick={handleAddLocation}
                sx={{ width: { xs: '100%', sm: 'auto' } }}
            />
        </Toolbar>
    );
};

export default LocationToolbar;
